import React, { useState } from 'react';
import { LivePage, FilterBar, DataTable, StatusBadge, Age, Code, clustersAPI } from './LivePage';

export default function PVs() {
  const [nameFilter, setNameFilter] = useState('');

  return (
    <LivePage title="Persistent Volumes" fetchFn={id => clustersAPI.getWorkloadPaged('persistentvolumes', id, { pageSize: 500 })}>
      {(data) => {
        // Agent clusters return a raw K8s List (mixed items); normalize PersistentVolume items.
        const _raw = data.pvs || (data.items || []);
        const items = _raw
          .filter(it => (it.kind || 'PersistentVolume') === 'PersistentVolume')
          .map(it => it.metadata ? {
            name: it.metadata.name,
            capacity: (it.spec?.capacity || {}).storage || '',
            access_modes: (it.spec?.accessModes || []).join(','),
            reclaim_policy: it.spec?.persistentVolumeReclaimPolicy || '',
            status: it.status?.phase || 'Unknown',
            storage_class: it.spec?.storageClassName || '',
            created_at: it.metadata.creationTimestamp,
          } : it);
        const filtered = items.filter(p => p.name.toLowerCase().includes(nameFilter.toLowerCase()));
        return <>
          <FilterBar count={filtered.length} total={items.length} label="PVs">
            <input placeholder="Filter by name..." value={nameFilter} onChange={e => setNameFilter(e.target.value)} />
          </FilterBar>
          <DataTable cols={['Name', 'Capacity', 'Access Modes', 'Reclaim Policy', 'Status', 'Storage Class', 'Age']}
            rows={filtered.map(p => (
              <tr key={p.name}>
                <td><Code>{p.name}</Code></td>
                <td style={{ fontWeight: 600 }}>{p.capacity}</td>
                <td style={{ fontSize: 12 }}>{p.access_modes}</td>
                <td style={{ fontSize: 12 }}>{p.reclaim_policy}</td>
                <td><StatusBadge status={p.status} /></td>
                <td style={{ fontSize: 12 }}>{p.storage_class}</td>
                <td><Age ts={p.created_at} /></td>
              </tr>
            ))} />
        </>;
      }}
    </LivePage>
  );
}
